/**
 * * Модель сотрудника
 */
export class UserModel {
  /**ID */
  Id!: number;
  /** Имя */
  FirstName: string;
  /**  Фамилия */
  LastName: string;
  /** Отчетсво */
  MiddleName: string;
  /**Почта */
  Email: string = "";
  /**Аватарка */
  ImageUrl!: string;
  /**Цвет аватарки */
  AvatarColor: string = "#FF5431";

  constructor(obj?: Partial<UserModel>) {
    Object.assign(this, obj);
  }
}
